import { useEffect, useState } from 'react';
import { IHttpApi } from '@cian/http-api';
import { getHttpApi } from '@cian/http-api/browser';

export const useHttpApi = () => {
  const [httpApi, setHttpApi] = useState<IHttpApi>();
  useEffect(() => {
    setHttpApi(getHttpApi());
  }, []);

  return httpApi;
};
